import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { AffiliationsService } from '../../../../../../core/lists/_services';

@Component({
  selector: 'kt-doctor-affiliations',
  templateUrl: './doctor-affiliation.component.html',
  styleUrls: ['./doctor-affiliation.component.scss'],
})
export class DoctorAffiliationComponent implements OnInit {
  selectable = true;
  removable = true;
  filteredAffiliations;
  @ViewChild('affiliationInput') entityInput: ElementRef<HTMLInputElement>;
  affiliationList: any = [];
  affiliationValue: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() controlObject: FormControl;
  @Input() readOnlyValue;
  @Input() appearance;
  @Input() readOnly;
  @Input() value;

  constructor(private affiliationService: AffiliationsService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.readOnly) {
      this.selectable = false;
      this.removable = false;
      this.affiliationList = [...this.readOnlyValue];
    } else {
      this.controlObject.valueChanges.subscribe((value) => {
        if (!value) {
          this.affiliationList = [];
          this.entityInput.nativeElement.value = '';
        }
      });
    }

    if (this.value) {
      this.value.subscribe((value) => {
        this.affiliationList = value;
        this.updateModel();
        this.cdr.detectChanges();
      });
    }
  }

  affiliationInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredAffiliations = this.affiliationService.searchAffiliations(value).pipe(
          map((res) =>
            res.data.filter((r) => {
              return !this.affiliationList.find((e: any) => e.id === r.id);
            }),
          ),
        );
    } else {
      this.filteredAffiliations = of([]);
    }
  }

  getAffiliationDescription(affiliation) {
    return affiliation.name;
  }

  remove(entity: string): void {
    const index = this.affiliationList.indexOf(entity);

    if (index >= 0) {
      this.affiliationList.splice(index, 1);
    }

    this.updateModel();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.affiliationList.push(event.option.value);
    this.entityInput.nativeElement.value = '';
    this.updateModel();
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.affiliationList.push({ name: value.trim() });
      this.entityInput.nativeElement.value = '';
    }
    this.updateModel();
  }

  updateModel() {
    this.controlObject.setValue(
      this.affiliationList.map((affiliation) =>
        affiliation.id ? { id: affiliation.id } : { name: affiliation.name },
      ),
    );
  }
}
